import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, createElementVNode as _createElementVNode, createVNode as _createVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex bg-top text-top py-4 px-3 transition-colors" }
const _hoisted_2 = { class: "flex-1 min-w-0 mr-2 flex items-center" }
const _hoisted_3 = { class: "px-2 truncate text-lg w-full" }

import NavigationCloseButton from "@/features/shared/NavigationCloseButton.vue";
import NavigationBackButton from "@/features/shared/NavigationBackButton.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'NavigationHeader',
  props: {
  includeBack: {
    type: Boolean,
    required: false,
    default: () => false,
  },
},
  emits: ["close", "back"],
  setup(__props, { emit: __emit }) {

const emits = __emit;



function onCloseClick() {
  emits("close");
}

function onBackClick() {
  emits("back");
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (__props.includeBack)
      ? (_openBlock(), _createBlock(NavigationBackButton, {
          key: 0,
          onClick: onBackClick
        }))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _renderSlot(_ctx.$slots, "default")
      ])
    ]),
    _createVNode(NavigationCloseButton, { onClick: onCloseClick })
  ]))
}
}

})